import * as angular from "angular";
import {IController} from "angular";

export class agreementsTableHeaderCtrl implements IController {

  constructor() {
  }


}

angular
  .module('bringoz.admin.agreements')
  .component('agreementsTableHeader', {
    bindings: {},
    template: require('./agreements-table-header.html').default,
    controller: agreementsTableHeaderCtrl
  });
